import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'withoutbar'
})
export class WithoutbarPipe implements PipeTransform {
  transform(tag: string): string {
    let str = tag.replace('$', '\n');
    if(tag != '')
    {
      let alphabet:any = "abcdefghijklmnopqrstuvwxyz0123456789".split("");

      alphabet.forEach(element => str = str.replace("|"+element, " "));
      if(str.indexOf("=")>0)
      {
        return str.replace("|", " ").replace("UNAUTHORIZED", "").substring(0, str.indexOf("="));
      } else{
        return str.replace("|", " "); 
      } 
    } else {
      return "";
    }
  }

}
